import finance from "./finance";
import tuition from "./tuition";

/**
 * 华博特项目接口文档
 */
export default {
  finance,
  tuition,
};
